const Attributes:any = {
	"Label": {"type": "textarea", rows: 5, index: 100},
	"Notes": {"type": "textarea", rows: 5, index: 100},
	"Color": {"type": "color", index: 99},
	"FontSize": {"type": "number", "range": {min: 8, max: 72}, step: 1, index: 98},
	"opacity": {"type": "range", "range": {min: 0, max: 1}, step: 0.1, autoSave: true},
	"length": {"type": "number"},
	"area": {"type": "number"},
	"area-m2": {"type": "number"},
	"area-ha": {"type": "number"},
	"area-sqkm": {"type": "number"},
}

export default Attributes;